import { render, staticRenderFns } from "./SignTransferComponent.vue?vue&type=template&id=84d19f38&"
import script from "./SignTransferComponent.vue?vue&type=script&lang=js&"
export * from "./SignTransferComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports